module.exports = __webpack_public_path__ + "img/icon-c-withdraw.589d7935.png";